<template>
  <div class="top-brand-icons-list">
    <a
      v-for="brand in brands"
      :key="brand.id"
      :href="`/brands/${brand.id}`"
      class="top-brand-icon-link"
    >
      <TopBrandIcon
        :image-url="brand.top_image_url"
        :alt-text="brand.screen_name"
      />
    </a>
  </div>
</template>

<script>
import TopBrandIcon from '../../atoms/icons/TopBrandIcon'
export default {
  components: { TopBrandIcon },
  props: {
    brands: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.$emit('mount')
    })
  }
}
</script>

<style lang="scss" scoped>
.top-brand-icons-list {
  @extend %custom-scrollbar;
  display: flex;
  overflow: visible;
}

.top-brand-icon-link {
  &:not(:last-child) {
    margin-right: 8px;
  }
}
</style>
